import script from "./Movies.vue?vue&type=script&setup=true&lang=js"
export * from "./Movies.vue?vue&type=script&setup=true&lang=js"

import "./Movies.vue?vue&type=style&index=0&id=d62c30c2&lang=scss&scoped=true"

import exportComponent from "/Volumes/Quoicoubeh/Paraleclypse/website/paraleclypse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d62c30c2"]])

export default __exports__